import React, { FunctionComponent } from "react";

import {
  SiteConfig_siteConfig_tradingConf,
  SiteConfig_siteConfig_algorithmsConf,
} from "graphql/generated";

import Prediction from "./prediction";
import Control from "../control";
import { useLiveMeasurements } from "scenes/site/hooks";


interface IProps {
  siteId: string;
  tradingConf: SiteConfig_siteConfig_tradingConf;
  algorithmsConf: SiteConfig_siteConfig_algorithmsConf;
}


const Trading: FunctionComponent<IProps> = ({
  siteId,
  tradingConf,
  algorithmsConf,
}) => {
  const { data: tradingData } = useLiveMeasurements(siteId, "trading");
  const { data: plcData } = useLiveMeasurements(siteId, "plc");

  return (
    <>
      <Control algorithmsConf={algorithmsConf} data={plcData} />
      <Prediction tradingConf={tradingConf} data={tradingData} />
    </>
  );
};

export default Trading;
